// 登录组件
<template>
  <div class="login-box">
    <van-field
      v-if="mobileLoginStatus == 1"
      class="input-item"
      left-icon="manager"
      label="账号"
      v-model.trim="name"
      clearable
      placeholder="请输入您的登录名或手机号"
    ></van-field>
    <van-field
      v-if="mobileLoginStatus == 1"
      class="input-item"
      label="密码"
      :type="isShowPW ? 'password' : ''"
      left-icon="lock"
      :right-icon="isShowPW ? 'closed-eye' : 'eye-o'"
      @click-right-icon="isShowPW = !isShowPW"
      v-model.trim="password"
      clearable
      placeholder="请输入您的密码"
    ></van-field>
    <van-field
      v-if="mobileLoginStatus == 2"
      class="input-item"
      left-icon="phone"
      v-model.trim="mobile"
      label="手机号"
      clearable
      placeholder="请输入手机号码"
    ></van-field>
    <van-field
      v-if="mobileLoginStatus == 2"
      class="input-item"
      v-model="code"
      left-icon="edit"
      center
      label="验证码"
      clearable
      placeholder="请输入短信验证码"
    >
      <van-button
        :disabled="isDisabled"
        slot="button"
        size="small"
        type="primary"
        @click="getCode"
      >
        {{isSend? time + 's后重新获取':'获取验证码'}}
      </van-button>
    </van-field>
    <div class="btn-list">
      <span @click="go('getPassword')">忘记密码?</span>
      <span @click="mobileLogin">{{
        mobileLoginStatus === 1 ? "手机号码登录" : "账号密码登录"
      }}</span>
      <!-- <span>意见反馈</span> -->
    </div>
    <van-button class="loginBtn" type="primary" size="large" @click="login">登录</van-button>
    <!-- <van-button class="loginBtn" type="primary" size="large" @click="go('registerBox')" plain>注册</van-button> -->
  </div>
</template>

<script>
import { Field, Button, Toast } from "vant";
import { getUser } from "@/api/dictionary";
import {
  getDivisionData,
  getCommonDictionary,
  getMobileLoginCode,
} from "@/api/login";
import { mapActions, mapMutations } from "vuex";
import { setSessionStore } from "@/utils/sessionStorage";

export default {
  data() {
    return {
      name: "",
      password: "",
      isShowPW: true,
      screenHeightNoChange: true,
      grant_type: "password",
      mobileLoginStatus: 1,
      time: 60,
      isSpend: false,
      isDisabled: false,
      mobile: "",
      code: "",
      userInfo:{},
      isSend:""
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
  },
  methods: {
    ...mapActions(["securityCheck"]),
    ...mapMutations(["setMemberInfo", "setTitleList", "setAddrList"]),
    go(type) {
      this.$router.push({ name: type });
    },
    getUserInfo() {
      return new Promise((resolve) => {
        getUser().then((res) => {
          if (res.success) {
            this.userInfo = res.result;
            this.setMemberInfo(res.result);
            setSessionStore("memberId", res.result.id);
            resolve();
          } else {
            Toast("用户信息获取失败");
          }
        });
      });
    },
    mobileLogin() {
      if (this.mobileLoginStatus == 1) {
        this.mobileLoginStatus = 2;
        this.grant_type = "sms";
      } else {
        this.mobileLoginStatus = 1;
        this.grant_type = "password";
      }
    },
    async getCode() {
      let mobile = this.mobile;

      if (this.isSpend) {
        return;
      }

      if (!this.$regexp.mobile(mobile)) {
        Toast("请输入正确的手机号");
        return false;
      }
      
      // 防止重复点击，立即锁定状态
      this.isSpend = true; 
      this.isSend = true; // 【新增】开启倒计时显示状态
      this.time = 60;     // 【建议】在此处重置时间，确保每次都是60秒开始

      let timestamp = new Date().getTime();
      let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
      let sign = this.$md5(data);
      
      // 注意：这里建议加上 catch 处理，如果接口失败，需要释放锁
      getMobileLoginCode({ mobile: mobile, sign: sign, timestamp: timestamp }).then((res) => {
        if (res.success) {
          this.count();
        } else {
          // 【重要】如果接口返回失败，需要恢复状态，否则按钮一直禁用且显示倒计时
          this.isSpend = false;
          this.isSend = false;
          Toast(res.message || "获取验证码失败");
        }
      }).catch(() => {
         // 【重要】网络异常等情况下也要恢复状态
         this.isSpend = false;
         this.isSend = false;
         Toast("获取验证码失败，请重试");
      });
    },
    count() {
      --this.time;
      if (this.time > 0) {
        setTimeout(() => {
          this.count();
        }, 1000);
      } else {
        // 倒计时结束
        this.isSpend = false;
        this.isSend = false; // 【新增】恢复为“获取验证码”状态
        this.time = 60;      // 【新增】重置时间，方便下次使用
      }
    },
    submit() {
      var params = {
        username: this.name,
        password: this.password,
        grant_type: this.grant_type,
        scope: "server",
        client_id: "mms_meeting",
        client_secret: 123456,
        mobile: this.mobile,
        code: this.code,
      };

      this.securityCheck(params)
        .then((res) => {
          this.getUserInfo()
            .then((res) => {
              this.$router.push({ name: "MemberCenter" });
              // this.$router.push({ name: 'fsHome' });
              // if (res.success) {
              //   // this.$router.push({ name: "userInfo" });
              //
              // }
            })
            .catch(() => {
              Toast("用户信息获取失败");
            });
        })
        .catch((res) => {
          Toast("登录失败");
        });
    },
    login() {
      if (this.mobileLoginStatus == 2) {
        if (!this.mobile) {
          Toast("手机号不能为空");
          return;
        } else if (!this.code) {
          Toast("验证码不能为空");
          return;
        }
      } else {
        if (!this.name) {
          Toast("用户名不能为空");
          return;
        } else if (!this.password) {
          Toast("密码不能为空");
          return;
        }
      }

      this.submit();
    },
  },
  mounted() {
    getCommonDictionary("TITLE").then((res) => {
      this.setTitleList(res.result);
    });

    //获取地址
    getDivisionData().then((res) => {
      this.setAddrList(res.result);
    });
    const self = this;
    window.onresize = () => {
      if (self.oldFullHeight) {
        self.screenHeightNoChange =
          document.documentElement.clientHeight === self.oldFullHeight;
      }
    };
  },
};
</script>

<style  lang="less" scoped>
.login-box {
  padding: 55px 0;
}
.input-item {
  padding: 0;
  padding-bottom: 12px;
  i {
    color: #aaa;
    margin-right: 10px;
  }
  & + .input-item {
    margin-top: 30px;
  }
}
.loginBtn {
  margin-top: 20px !important;
}
.btn-list {
  display: flex;
  margin: 30px 0;
  font-size: 14px;
  justify-content: space-between;
  color: #7d7d7d;
}
/deep/.van-field__label{ width:1.6rem}
</style>
